import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import DrawerLib from 'react-modern-drawer';
import * as S from './Drawer.styled';
export const Drawer = ({ isOpened, onClose, size, className = '', children, lockBackgroundScroll = true, showOverlay = true }) => {
    return (_jsxs(_Fragment, { children: [_jsx(S.DrawerStyles, {}), showOverlay && _jsx(S.DrawerOverlayStyles, {}), _jsx(DrawerLib, { open: isOpened, onClose: onClose, direction: "right", size: size, className: className, lockBackgroundScroll: lockBackgroundScroll, 
                // ? We should centralize these numbers somewhere
                zIndex: 8, children: _jsx(S.DrawerContainer, { children: children }) })] }));
};
//# sourceMappingURL=Drawer.js.map